export { default } from './FormPage.vue'
